<div class="card-widget-list px-4" role="list" siatEqualStatusBadgeWidth>
  @if (tableRows.length === 0) {
    <div role="listitem">
      <p class="card-widget-empty">{{ 'GENERAL.no_data' | translate }}</p>
    </div>
  }

  @for (row of tableRows; track row['id'] ?? $index) {
    @if (stackedChips) {
      <div class="card-widget-row card-widget-row--stacked" role="listitem">
        <ng-container
          [ngTemplateOutlet]="rowName"
          [ngTemplateOutletContext]="{ $implicit: row }"
        />
        <div class="card-widget-chips">
          @for (label of labels; track label; let i = $index) {
            @if (i > 0 && row?.[label]) {
              <ng-container
                [ngTemplateOutlet]="rowChip"
                [ngTemplateOutletContext]="{
                  $implicit: row,
                  label: label,
                  chipClass: 'card-widget-chip',
                }"
              />
            }
          }
        </div>
      </div>
    } @else {
      <div
        class="card-widget-row max-sm:flex-wrap max-sm:items-start"
        role="listitem"
      >
        @for (label of labels; track label; let i = $index) {
          @if (i === 0) {
            <ng-container
              [ngTemplateOutlet]="rowName"
              [ngTemplateOutletContext]="{ $implicit: row }"
            />
          } @else {
            <ng-container
              [ngTemplateOutlet]="rowChip"
              [ngTemplateOutletContext]="{
                $implicit: row,
                label: label,
                chipClass: 'status-badge max-sm:max-w-full max-sm:self-start',
              }"
            />
          }
        }
      </div>
    }
  }
</div>

<ng-template #rowName let-row>
  @if (widget.config?.path?.detail || widget.config?.path?.download) {
    <button
      [disabled]="lockedPatient"
      class="card-widget-name max-sm:basis-full max-sm:min-w-0"
      (click)="onRowClick(row)"
      [attr.aria-label]="getRowName(row)"
    >
      <span
        class="card-widget-name-text max-sm:block max-sm:overflow-visible max-sm:text-clip max-sm:whitespace-normal max-sm:wrap-break-word"
        >{{ getRowName(row) }}</span
      >
    </button>
  } @else {
    <p
      class="card-widget-name-text max-sm:basis-full max-sm:block max-sm:overflow-visible max-sm:text-clip max-sm:whitespace-normal max-sm:wrap-break-word"
    >
      {{ getRowName(row) }}
    </p>
  }
</ng-template>

<ng-template #rowChip let-row let-label="label" let-chipClass="chipClass">
  <mat-chip
    [disableRipple]="true"
    [ngClass]="[chipClass, getPicStatusClass(row?.[label])]"
    [attr.aria-label]="row?.[label]"
  >
    {{
      isDate(row?.[label])
        ? (sanitizeDate(row?.[label]) | date: 'dd/MM/yyyy HH:mm')
        : (row?.[label] ?? '')?.toUpperCase()
    }}
  </mat-chip>
</ng-template>
